import React, { useContext, useEffect, useState } from "react";
import { PlaceColors } from "../genericPages/helpers/PlaceColors";
import { FindifyDataContext } from "@/contexts/FindifyDataContext";
import { FindifySimpleHeader, SimpleHeaderAction } from "../genericPages/components/FindifySimpleHeader";
import { PlaceText } from "../genericPages/components/PlaceText";
import { getApiFromModule } from "../genericPages/helpers/GetContentsByModule";
import { FlatList, Pressable, ScrollView, Share, StyleSheet, View } from "react-native";
import { useTranslation } from "react-i18next";
import { IconShadow } from "../genericPages/helpers/DefaultShadows";
import { BasePage } from "../genericPages/helpers/BasePage";
import { getTranslatedString } from "../genericPages/helpers/FindifyTranslatedString";
import Icon from "react-native-vector-icons/Ionicons";
import { getFeaturedImageUrl, getUniqueDays, makeStartTimeString } from "../genericPages/helpers/DetailsHelpers";
import { EventsListItemLine } from "./PlaceTab";
import { BottomNavigationPadding } from "../genericPages/components/FindifyNavigation";
import { useSafeAreaInsets } from "react-native-safe-area-context";



export const SchedulePage = ({ navigation }: any) => {
    const findifyDataContext = useContext(FindifyDataContext);
    const [events, setEvents] = useState<any[]>([]);
    const [availableDays, setAvailableDays] = useState<any[]>([]);
    const [selectedDayEvents, setSelectedDayEvents] = useState<any[]>([]);
    const [selectedDate, setSelectedDate] = useState<any>(null);
    const [sameYearDates, setSameYearDates] = useState(true);
    const { t } = useTranslation();
    const weekdays = [t('base.day.sun'), t('base.day.mon'), t('base.day.tue'), t('base.day.wed'), t('base.day.thu'), t('base.day.fri'), t('base.day.sat')];
    const [actionsList, setActionsList] = useState<SimpleHeaderAction[]>([]);
    const insets = useSafeAreaInsets();
    const [scheduleMenuItem, setScheduleMenuItem] = useState<any>({});

    useEffect(() => {
        const menuItem = (findifyDataContext?.workspace?.app_settings?.app_menu_lines ?? []).find((m: any) => m.module === 'schedule' && m.type === 'module');
        setScheduleMenuItem(menuItem);

        getApiFromModule('events', findifyDataContext)?.getList(0, 200, null, null, { orderby: JSON.stringify({ start_date: "ASC" }) }).then((res: any) => {
            const evs = res.results;
            setEvents(evs);
            const avDays = getUniqueDays(evs, setSameYearDates);
            setAvailableDays(avDays);
            setSelectedDate(avDays[0]);
        });

        setActionsList([{
            icon: 'share-outline',
            action: async () => {
                const result = await Share.share({
                    title: t('modules.content_types.events') + ' - ' + getTranslatedString(findifyDataContext?.workspace?.name, findifyDataContext) + ' - Findify',
                    message: `https://${findifyDataContext.workspace?.primary_domain?.domain_name ?? 'links.findify.cloud'}/dynamicLink?workspace_id=${findifyDataContext.workspace?.workspace_id}&type=list&module=events`,
                }, {
                    dialogTitle: getTranslatedString(findifyDataContext?.workspace?.name, findifyDataContext) + ' - Findify',
                });
            }
        }]);
    }, [])

    useEffect(() => {
        if (selectedDate) {
            const evs = events.filter((e: any) => e.start_date.startsWith(selectedDate));
            setSelectedDayEvents(evs);
        }
    }, [selectedDate])


    return <BasePage navigation={navigation}>
        {/* <FindifyTopBarOverlay /> */}
        <FlatList
            key={'eventsListAgenda'}
            data={selectedDayEvents.map((event: any) => {
                const dateStart = new Date(event?.start_date);
                const dateEnd = new Date(event?.end_date);

                const dateString = makeStartTimeString(dateStart) + ' - ' + makeStartTimeString(dateEnd);
                // const dateString = 'TOdo'
                return {
                    ...event,
                    id: event.event_id,
                    title: event.name,
                    image: getFeaturedImageUrl(event),
                    date: dateString,
                    onPress: () => {
                        navigation.push('PlaceContentDetails', {
                            module: 'events',
                            event_id: event.event_id,
                            page_slug: event.page_slug
                        })
                    }
                }
            })}
            numColumns={1}
            ListHeaderComponent={() => <>
                <FindifySimpleHeader
                    isEventLayout
                    navigation={navigation}
                    title={scheduleMenuItem ? getTranslatedString(scheduleMenuItem.label, findifyDataContext) : t('modules.schedule')}
                    actions={actionsList}
                />
                <View style={[styles.dateZone, { backgroundColor: PlaceColors(findifyDataContext).background.get() }]}>
                    <ScrollView
                        bounces={false}
                        showsHorizontalScrollIndicator={false}
                        showsVerticalScrollIndicator={false}
                        horizontal={true}
                        contentContainerStyle={{
                            minWidth: '100%',
                            width: '100%',
                        }}
                    >
                        <View
                            style={[
                                {
                                    display: 'flex',
                                    flexDirection: 'row',
                                    justifyContent: 'center',
                                    minWidth: '100%',
                                    width: '100%',
                                    gap: 4,
                                },
                            ]}
                        >
                            {availableDays.length > 0 &&
                                availableDays.map((day: any, index: any) => {
                                    const date = new Date(day);
                                    return (<Pressable onPress={() => setSelectedDate(day)}>
                                        <View style={{
                                            backgroundColor: selectedDate === day ? PlaceColors(findifyDataContext).text.withAlpha(80) : 'transparent',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            padding: 6,
                                            gap: 4,
                                            alignItems: 'center',
                                            borderRadius: 100,
                                            aspectRatio: 1,
                                            borderWidth: 1,
                                            borderColor: PlaceColors(findifyDataContext).secondary.get(),


                                        }}>
                                            <PlaceText style={{ color: PlaceColors(findifyDataContext).text.get(), textTransform: 'capitalize', fontWeight: 'bold' }}>{weekdays[date.getDay()]}</PlaceText>
                                            <PlaceText style={{ color: PlaceColors(findifyDataContext).text.get() }}>{date.toLocaleDateString(undefined, { day: '2-digit', month: 'numeric', year: sameYearDates ? undefined : 'numeric' })}</PlaceText>
                                        </View>
                                    </Pressable>);
                                })
                            }
                        </View>
                    </ScrollView>
                </View>
            </>
            }
            showsVerticalScrollIndicator={false}
            showsHorizontalScrollIndicator={false}
            renderItem={({ item, index }) => {
                return EventsListItemLine(1, item, index, findifyDataContext, selectedDayEvents.length);
            }}
            bounces={false}
            keyExtractor={(item, index) => index.toString()}
            contentContainerStyle={[{
                paddingBottom: insets.bottom + BottomNavigationPadding,
            }]}
        />
    </BasePage>
};

const styles = StyleSheet.create({
    topNav: {},
    dateZone: {
        width: '100%',
        marginBottom: 10,

    },
    bottomBox: {
        flex: 1,
    },

    headerIcon: {
        padding: 5,
        ...IconShadow,
    }
})
